import { render, staticRenderFns } from "./GoodsItem.vue?vue&type=template&id=aed75b78&scoped=true"
import script from "./GoodsItem.vue?vue&type=script&lang=js"
export * from "./GoodsItem.vue?vue&type=script&lang=js"
import style0 from "./GoodsItem.vue?vue&type=style&index=0&id=aed75b78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aed75b78",
  null
  
)

export default component.exports